export enum CompanyStatusEnum
{
    UnderReview = 0,
    Verified = 1
}